import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiBlobGetRequest,
} from '../../api';
import { _ } from 'vue-underscore';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title_supplier: 'Laporan Supplier Produk',
    title_pakai_unit: 'Laporan Pemakaian Unit',
    title_stokmasuk: 'Laporan Penerimaan Produk',
    title_penyesuaian: 'Laporan Penyesuaian Stok',
    title_form: 'Form Penyesuaian Stok',
    title_pembelian: 'Laporan Pembelian',
    title_alat_berat: 'Laporan Alat Berat',
    title_penjualan: 'Laporan Penjualan',
    title_returbeli: 'Laporan Retur Pembelian',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Penyesuaian Stok',
        href: '/adm/logistic/penyesuaian-stok',
        active: true,
      },
    ],
    tab: [
      {
        name: 'Supplier',
        active: true,
      },
      {
        name: 'Kode Akun dan HPP',
        active: false,
      },
    ],
    formProduct: {
      name: '',
      stock: '',
      min_stock: '',
      unit: '',
      price_buy: '',
      price_sale: '',
      brand: '',
      supplier_product: [
        {
          id_supplier: '',
          name_supplier: '',
          price_buy: '',
          disc: '',
          ppn: '',
          price_final: '',
        },
        {
          id_supplier: '',
          name_supplier: '',
          price_buy: '',
          disc: '',
          ppn: '',
          price_final: '',
        },
      ],
    },
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields_supplier_produk: [
      {
        key: 'kode',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'produk',
        label: 'Produk',
        sortable: true,
      },
      {
        key: 'satuan',
        label: 'Satuan',
        sortable: true,
      },
      {
        key: 'merk',
        label: 'Merk',
      },
      {
        key: 'part_number',
        label: 'Part Number',
      },
      {
        key: 'harga_beli',
        label: 'Harga Beli',
      },
      {
        key: 'harga_jual',
        label: 'Harga Jual',
      },
      {
        key: 'merk',
        label: 'Merk',
      },
    ],
    fields_pakai_unit: [
      {
        key: 'kode',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'jenis',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'no_kendaraan',
        label: 'No Kendaraan',
        sortable: true,
      },
      {
        key: 'merk',
        label: 'Merk',
      },
      {
        key: 'plat_no',
        label: 'Plat No',
      },
      {
        key: 'tahun',
        label: 'Tahun',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_stokmasuk: [
      {
        key: 'kode',
        label: 'Stok No',
        sortable: true,
      },
      {
        key: 'purchase_no',
        label: 'Pembelian',
        sortable: true,
      },
      {
        key: 'supplier',
        label: 'Supplier',
        sortable: true,
      },
      {
        key: 'tgl_beli',
        label: 'Tgl Beli',
        sortable: true,
      },
      {
        key: 'tgl_masuk',
        label: 'Tgl Masuk',
        sortable: true,
      },
      {
        key: 'kode_produk',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'produk',
        label: 'Produk',
      },
      {
        key: 'qty',
        label: 'Jumlah',
      },
      {
        key: 'satuan',
        label: 'Satuan',
      },
    ],
    fields_stokkeluar: [
      {
        key: 'kode',
        label: 'Stok No',
        sortable: true,
      },
      {
        key: 'unit',
        label: 'Unit',
        sortable: true,
      },
      {
        key: 'tgl_keluar',
        label: 'Tgl Keluar',
        sortable: true,
      },
      {
        key: 'pic',
        label: 'PIC',
        sortable: true,
      },
      {
        key: 'kode_produk',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'produk',
        label: 'Produk',
      },
      {
        key: 'qty',
        label: 'Jumlah',
      },
      {
        key: 'satuan',
        label: 'Satuan',
      },
    ],
    fields_penyesuaian: [
      {
        key: 'kode',
        label: 'Stok No',
        sortable: true,
      },
      {
        key: 'tgl_penyesuaian',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'kode_produk',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'produk',
        label: 'Produk',
      },
      {
        key: 'qty',
        label: 'Jumlah',
      },
      {
        key: 'satuan',
        label: 'Satuan',
      },
      {
        key: 'merk',
        label: 'Merk',
      },
    ],
    fields_sisastok: [
      {
        key: 'kode',
        label: 'Stok No',
        sortable: true,
      },
      {
        key: 'tgl_penyesuaian',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'kode_produk',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'produk',
        label: 'Produk',
      },
      {
        key: 'qty_masuk',
        label: 'Masuk',
      },
      {
        key: 'qty_keluar',
        label: 'Keluar',
      },
      {
        key: 'sisa_stok',
        label: 'Sisa Stok',
      },
    ],
    fields_pembelian: [
      {
        key: 'code_order_beli',
        label: 'Kode',
      },
      {
        key: 'supplier',
        label: 'Supplier',
      },
      {
        key: 'tgl_beli',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'type_buy',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'total_invoice',
        label: 'Total',
      },
      {
        key: 'total_payment',
        label: 'Total Final',
      },
      {
        key: 'status_order_beli',
        label: 'Status',
      },
    ],
    fields_penjualan: [
      {
        key: 'code_order_jual',
        label: 'Kode',
      },
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'tgl_jual',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'type_sale',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'total_invoice',
        label: 'Total',
      },
      {
        key: 'total_payment',
        label: 'Total Final',
      },
      {
        key: 'status_order_jual',
        label: 'Status',
      },
    ],
    fields_returbeli: [
      {
        key: 'kode',
        label: 'Stok No',
        sortable: true,
      },
      {
        key: 'purchase_no',
        label: 'Pembelian',
        sortable: true,
      },
      {
        key: 'tgl_beli',
        label: 'Tgl Beli',
        sortable: true,
      },
      {
        key: 'tgl_retur',
        label: 'Tgl Retur',
        sortable: true,
      },
      {
        key: 'kode_produk',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'produk',
        label: 'Produk',
      },
      {
        key: 'qty',
        label: 'Jumlah',
      },
      {
        key: 'retur',
        label: 'Retur',
      },
      {
        key: 'satuan',
        label: 'Satuan',
      },
    ],
    fields_pemakaian_alat: [
      {
        key: 'tgl_stok',
        label: 'Tanggal',
      },
      {
        key: 'code_stok',
        label: 'Kode',
      },
      {
        key: 'no_kendaraan',
        label: 'Kendaraan',
        sortable: true,
      },
      {
        key: 'jenis',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'gudang',
        label: 'Gudang',
        sortable: true,
      },
      {
        key: 'item_qty',
        label: 'Quantity',
      },
    ],
    form: {
      id_supplier: '',
      supplier: '',
      supplier_code: '',
      supplier_name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  activeTab(state) {
    let tabActive = _.findWhere(state.data.tab, {
      active: true,
    });

    return tabActive ? tabActive.name : '';
  },
};

export const mutations = {
  changeLapLogistik(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getLapAlatBerat({ commit, state }) {
    commit('changeLapLogistik', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_alat_berat:
        data.form && data.form.id_alat_berat ? data.form.id_alat_berat : '',
      id_gudang: data.form && data.form.id_gudang ? data.form.id_gudang : '',
    };

    if (data.form.date_filter && data.form.date_filter.length > 0) {
      params.start_date = data.form.date_filter[0]
        ? moment(data.form.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.form.date_filter[1]
        ? moment(data.form.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiGetRequest(
      `logistic/pemakaian-stok/alat-berat`,
      params
    );
    commit('changeLapLogistik', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getExportLapAlatBerat({ commit, state }) {
    commit('changeLapLogistik', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_alat_berat:
        data.form && data.form.id_alat_berat ? data.form.id_alat_berat : '',
      id_gudang: data.form && data.form.id_gudang ? data.form.id_gudang : '',
    };

    if (data.form.date_filter && data.form.date_filter.length > 0) {
      params.start_date = data.form.date_filter[0]
        ? moment(data.form.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.form.date_filter[1]
        ? moment(data.form.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiBlobGetRequest(
      `logistic/pemakaian-stok/alat-berat`,
      params
    );
    commit('changeLapLogistik', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_pemakaian_alat.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },

  async getReportLapAlatBerat({ commit, state }) {
    commit('changeLapLogistik', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_alat_berat:
        data.form && data.form.id_alat_berat ? data.form.id_alat_berat : '',
      id_gudang: data.form && data.form.id_gudang ? data.form.id_gudang : '',
    };

    if (data.form.date_filter && data.form.date_filter.length > 0) {
      params.start_date = data.form.date_filter[0]
        ? moment(data.form.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.form.date_filter[1]
        ? moment(data.form.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiGetRequest(
      `logistic/pemakaian-stok/alat-berat`,
      params
    );
    commit('changeLapLogistik', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getLapPembelian({ commit, state }) {
    commit('changeLapLogistik', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_supplier:
        data.form && data.form.id_supplier ? data.form.id_supplier : '',
      status: data.form && data.form.status ? data.form.status : '',
      type: data.form && data.form.type ? data.form.type : '',
    };

    if (data.form.date_filter && data.form.date_filter.length > 0) {
      params.start_date = data.form.date_filter[0]
        ? moment(data.form.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.form.date_filter[1]
        ? moment(data.form.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiGetRequest(`logistic/order-beli`, params);
    commit('changeLapLogistik', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getExportLapPembelian({ commit, state }) {
    commit('changeLapLogistik', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_supplier:
        data.form && data.form.id_supplier ? data.form.id_supplier : '',
      status: data.form && data.form.status ? data.form.status : '',
      type: data.form && data.form.type ? data.form.type : '',
    };

    if (data.form.date_filter && data.form.date_filter.length > 0) {
      params.start_date = data.form.date_filter[0]
        ? moment(data.form.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.form.date_filter[1]
        ? moment(data.form.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiBlobGetRequest(`logistic/order-beli`, params);
    commit('changeLapLogistik', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_order_beli.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },

  async getReportLapPembelian({ commit, state }) {
    commit('changeLapLogistik', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_supplier:
        data.form && data.form.id_supplier ? data.form.id_supplier : '',
      status: data.form && data.form.status ? data.form.status : '',
      type: data.form && data.form.type ? data.form.type : '',
    };

    if (data.form.date_filter && data.form.date_filter.length > 0) {
      params.start_date = data.form.date_filter[0]
        ? moment(data.form.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.form.date_filter[1]
        ? moment(data.form.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiGetRequest(`logistic/order-beli`, params);
    commit('changeLapLogistik', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getLapPenjualan({ commit, state }) {
    commit('changeLapLogistik', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_supplier:
        data.form && data.form.id_supplier ? data.form.id_supplier : '',
      status: data.form && data.form.status ? data.form.status : '',
      type: data.form && data.form.type ? data.form.type : '',
    };

    if (data.form.date_filter && data.form.date_filter.length > 0) {
      params.start_date = data.form.date_filter[0]
        ? moment(data.form.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.form.date_filter[1]
        ? moment(data.form.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiGetRequest(`logistic/order-jual`, params);
    commit('changeLapLogistik', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getExportLapPenjualan({ commit, state }) {
    commit('changeLapLogistik', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_supplier:
        data.form && data.form.id_supplier ? data.form.id_supplier : '',
      status: data.form && data.form.status ? data.form.status : '',
      type: data.form && data.form.type ? data.form.type : '',
    };

    if (data.form.date_filter && data.form.date_filter.length > 0) {
      params.start_date = data.form.date_filter[0]
        ? moment(data.form.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.form.date_filter[1]
        ? moment(data.form.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiBlobGetRequest(`logistic/order-jual`, params);
    commit('changeLapLogistik', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_order_beli.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },

  async getReportLapPenjualan({ commit, state }) {
    commit('changeLapLogistik', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_supplier:
        data.form && data.form.id_supplier ? data.form.id_supplier : '',
      status: data.form && data.form.status ? data.form.status : '',
      type: data.form && data.form.type ? data.form.type : '',
    };

    if (data.form.date_filter && data.form.date_filter.length > 0) {
      params.start_date = data.form.date_filter[0]
        ? moment(data.form.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.form.date_filter[1]
        ? moment(data.form.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiGetRequest(`logistic/order-jual`, params);
    commit('changeLapLogistik', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async searchCustomer(context, params = null) {
    let result = await ApiGetRequest(`logistic/suppliers`, params);
    return !result.error ? result.data.object : [];
  },

  async getListCustomer({ commit, state }) {
    commit('changeLapLogistik', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      _limit: data.limit,
      _page: data.page,
      _sort: data.sortBy,
      _order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`logistic/suppliers`, params);
    commit('changeLapLogistik', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailCustomer({ commit }, payload = null) {
    commit('changeLapLogistik', {
      loading: true,
    });

    let result = await ApiGetRequest(`logistic/suppliers/${payload.id}`);
    commit('changeLapLogistik', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async createCustomer({ commit, state, dispatch }) {
    commit('changeLapLogistik', {
      loading: true,
    });

    let result = await ApiPostRequest(`logistic/suppliers`, state.data.form);
    commit('changeLapLogistik', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateCustomer({ commit, state, dispatch }, payload = null) {
    commit('changeLapLogistik', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `logistic/suppliers/${payload.id}`,
      state.data.form
    );

    commit('changeLapLogistik', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteCustomer({ commit, dispatch }, payload = null) {
    commit('changeLapLogistik', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`logistic/suppliers/${payload.id}`);
    commit('changeLapLogistik', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
